import { Col, Row } from 'antd';
import React from 'react';

function LastEdition(props) {
  return (
    <div style={{ overflowX: 'hidden' }} id='lastedition'>
        <Row justify="center" align='middle' gutter={[16, 16]}>
          <Col span={24} style={{ textAlign: 'center' }}>
            <h2><strong>Glimpse of the last edition</strong></h2>
          </Col>
          <Col xs={0} md={4} />
          <Col xs={24} md={16}>
            <div className="embed-responsive embed-responsive-16by9">
              <iframe
                className="embed-responsive-item"
                width="100%"
                height="500"
                src="https://www.youtube.com/embed/5F_hXojMXnE?si=Xpof8kCLsG5rYTt6"
                title="Glimpse of the last edition"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
          <Col xs={0} md={4} />
          {/* <Col xs={24} md={12} style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
  <h2 id="heading">In our last edition of Flipkart Connect</h2>
  <p style={{ fontWeight: "lighter", maxWidth: "max-content" }}>
    We explored the impact of emerging tech and consumer trends on e-commerce.<br /> 
    The event featured an inspiring keynote by Guy Kawasaki, a dynamic panel led by <br /> 
    Tanmay Bhat on the evolution of brands in a new era, and much more—making <br />
    it a must-attend for leaders in digital commerce innovation.
  </p>
</Col> */}
        </Row>
    </div>
  );
}

export default LastEdition;
